import React, { useEffect, useState, createContext } from 'react';

const WidthContext = createContext(window.innerWidth);

function WidthContextProvider({ children }) {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize, { passive: true });
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return <WidthContext.Provider value={width}>{children}</WidthContext.Provider>;
}

export { WidthContext, WidthContextProvider };
